'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.buildTree = buildTree;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoreKeys = ['emojis', 'themes', 'bnc', 'aliases', 'restricted', 'kiwiServer', 'hide_advanced', 'windowTitle', 'startupOptions', 'plugins', 'presetNetworks'];

function buildTree(data, base, object, modified) {
    (0, _keys2.default)(object).forEach(function (key) {
        var value = object[key];
        var ourBase = base.concat([key]);
        if (['string', 'boolean', 'number'].indexOf(typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== -1) {
            if (ignoreKeys.indexOf(key) !== -1 || (ourBase[0] && ignoreKeys.indexOf(ourBase[0])) !== -1) {
                return;
            }

            if (!data[ourBase.join('.')] || data[ourBase.join('.')].val !== value) {
                data[ourBase.join('.')] = {
                    key: ourBase.join('.'),
                    val: value,
                    type: typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value),
                    modified: modified
                };
            }
        } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
            buildTree(data, ourBase, value, modified);
        }
    });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["settingTools"]
window._kiwi_exports.libs.settingTools = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/settingTools.js
// module id = vwdH
// module chunks = 1